import { useEffect } from "react";
import LoginScreen from "./screens/Login/LoginScreen";
import { useDispatch, useSelector } from "react-redux";
import SuperAdminRoutes from "./routes/SuperAdminRoutes";
import SocketProvider from "./socket/SocketProvider";
import SnackBar from "./components/SnackBar";
import { setPrimaryColor } from "./redux/reducers/colorReducers";
import HRRoutes from "./routes/HRRoutes";

function App() {
  
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user)
  
  const primaryColor = useSelector((state) => state.color.primaryColor)

  const dispatch = useDispatch()


  useEffect(() => {
    dispatch(setPrimaryColor('#246AFD'))
    document.documentElement.style.setProperty('--primary-color', primaryColor)
  }, [primaryColor]);

  return (
    <div style={{ '--primary-color': primaryColor }}>
      {
          isAuthenticated ? (
            user?.dept_id === 1 ?
            <SuperAdminRoutes />:
            <HRRoutes />
          ):
          <LoginScreen />
      }
      <SnackBar />
      <SocketProvider />
    </div>
  );
}

export default App;
